import React from 'react';
import { connect } from 'react-redux';
import WhatIfResultsListPres from '../presentational/WhatIfResultsListPres';
import { setPageType, selectResult, deleteSelected, setDetailIndex } from '../state/whatIfActions';

class WhatIfResultsListContainer extends React.Component {
  componentDidMount() {}

  onCompare = () => {
    this.props.setPageType('compare');
  };

  onDelete = () => {
    this.props.deleteSelected();
  };

  onDetail = index => {
    this.props.setPageType('detail');
    this.props.setDetailIndex(index);
  };

  onViewExcel = () => {
    this.props.setPageType('excel');
  };

  handleResultCancel = index => {
    // this.props.removeResult(index);
  };

  handleResultSelect = index => {
    this.props.selectResult(index);
  };

  render() {
    return (
      <WhatIfResultsListPres
        {...this.props}
        {...this.state}
        onCompare={this.onCompare}
        onDelete={this.onDelete}
        onDetail={this.onDetail}
        onViewExcel={this.onViewExcel}
        handleResultCancel={this.handleResultCancel}
        handleResultSelect={this.handleResultSelect}
      />
    );
  }
}

const mapStateToProps = state => ({
  results: state.whatIf.results,
  maxCompensation: state.whatIf.maxCompensation,
});

const mapDispatchToProps = {
  setPageType,
  selectResult,
  deleteSelected,
  setDetailIndex,
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatIfResultsListContainer);
